import {CurrencyFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {Money} from '@dms/api/shared';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {formatCurrencyOrDash} from './formatCurrencyOrDash';

/**
 * Formats a money value for read-only display. A missing value, or an amount the currency
 * formatter rejects, is shown as a dash instead of an empty space.
 */
export function formatMoney(formatCurrency: CurrencyFormatter, money: Money | Nullish) {
  return isNil(money)
    ? EMPTY_PLACEHOLDER
    : formatCurrencyOrDash(formatCurrency, Number(money.amount), money.currency);
}
